import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import { messageAction } from '../actions/app.action'
import store from '../store'

export let showMessageGlobal = null

const ClientWrapper = ({ children }) => {
  const [message, setMessage] = React.useState({})
  showMessageGlobal = setMessage

  React.useEffect(() => {
    if (!isEmpty(message) && message.message) {
      store.dispatch(
        messageAction({
          subTitle: message.message,
          severity: message.severity,
        })
      )
    }
  }, [message])

  return <>{children}</>
}

ClientWrapper.propTypes = {
  children: PropTypes.element,
  showBanner: PropTypes.bool,
}

ClientWrapper.defaultProps = {
  children: null,
  showBanner: false,
}

export default ClientWrapper
